import { getDeviceType, getGradeFromOnboardingData, getUserSignupFlow, highestGradeCode, isOnboardingIncomplete } from "./web-helper";

export const getMode = (settingsData = {}) => {
    let mode = 'b2chome'; // for B2C users

    // for b2b and ptl
    if(settingsData && settingsData.is_classroom_student) {
        mode = settingsData?.restriction_info?.selected_mode
    }
    return mode;
}

export const getSignupFlow = (settingsData = {}) => {
    if(settingsData?.user_signup_flow) {
        return settingsData.user_signup_flow;
    }
    else if(settingsData?.via_teacher_student_center) {
        return "student_experience";
    }
    if(settingsData?.is_classroom_student) {
        return "classcode";
    }
    return getUserSignupFlow();
}

export const getUserType = (settings) => {
    if(settings && settings.logged_in_guardian_type == "teacher") {
      return "Student";
    }
    else {
      return "Parent";
    }
}

export const appendBaseParams = ({ settings = {}, courses = [], mathGrade, elaGrade, grade = "", signupFlow = "" }) => {
    if(isOnboardingIncomplete() && (grade == "" || courses.length == 0)) {
        grade = getGradeFromOnboardingData();
        mathGrade = grade;
        elaGrade = grade;
    }
    else {
        grade = grade || highestGradeCode(courses);
    }
    const baseEventProperties = {
        mode: getMode(settings),
        signupFlow: signupFlow != "" ? signupFlow : getSignupFlow(settings),
        platform: getDeviceType(),
        userType: getUserType(settings),
        ...(grade && { grade:  grade }),
        ...(mathGrade && { mathGrade: mathGrade }),
        ...(elaGrade && { elaGrade: elaGrade })
    }
    return baseEventProperties;
}

export const appendUserParams = ({ settings = {}, signupFlow = "" }) => {
    const baseEventProperties = {
        signupFlow: signupFlow != "" ? signupFlow : getSignupFlow(settings),
        platform: getDeviceType(),
        userType: getUserType(settings)
    }
    return baseEventProperties;
}